import { useGetHolidayHours } from 'queries';

export const useGetTableData = () => {
  const { data, isFetching } = useGetHolidayHours();

  return { data, isFetching };
};
